import styled from 'styled-components';

export const HeaderDetailsContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`;

export const CardNumber = styled.h2`
    align-items: center;
    color: #C0C0C0;
    display: flex;
    font-weight: 700;
    flex-shrink: 0;
    margin: 0;
    opacity: 0.4;
`;

export const TagsContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: 4px;
    min-height: 28px;
    min-width: 0;
`;

export const Name = styled.h2`
    align-items: center;
    color: #FFFFFF;
    display: flex;
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 700;
    margin: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;